import React, {FC} from 'react';
import {Link} from "react-router-dom";
import {ReactComponent as ArrayIcon} from '../../../../../assets/main/groups/main-table/array.svg';
import {Group} from "features/model/types/groups/groupsSchema";



interface IActsItemProps {
    group: Group;

}

export const GroupItems: FC<IActsItemProps> = ({ group}) => {

    return (
        <div className="row" key={group.id}>
            <div className="col group-name-col full-width-mobile">
                <span className="col-title">Название группы</span>
                <Link to={`/groups/${group.id}`}>{group.title}</Link>
            </div>
            <div className="col level-col">
                <span className="col-title">Уровень</span>
                <p>{group.languageLevel}</p>
            </div>
            <div className="col students-col">
                <span className="col-title">Студенты</span>
                <div className="students-number">
                    {group.users && group.users.items && group.users.items.length > 0 ? (
                        group.users.items.map((user, index) => (
                            <div className='avatar' key={index}>
                                {user.avatar ? (
                                    <img src={user.avatar} alt={`Student Avatar ${index}`} />
                                ) : null}
                            </div>
                        ))
                    ) : (
                        <p>No students</p>
                    )}
                    {group.users && group.users.count ? (
                        <span className="num">{group.users.count}</span>
                    ) : null}
                </div>
            </div>
                <div className="col company-col full-width-mobile">
                    <span className="col-title">Компания</span>
                    <p>{group.company && group.company.title ? group.company.title : ''}</p>
                </div>

            <div className="col btn-link-col">
                <Link style={{ boxShadow: 'none' }} to={`/groups/${group.id}`} className="circle-arrow-btn">
                    <ArrayIcon />
                </Link>
            </div>
        </div>
    );
};
